import React from 'react';
import TableContainerMui, { TableContainerProps } from '@material-ui/core/TableContainer';

export const TableContainer: React.FC<TableContainerProps> = ({ children, ...rest }) => {
	return <TableContainerMui {...rest}>{children}</TableContainerMui>;
};
